import axios from 'axios'

// Configure axios defaults
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor for handling common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response || {}

    if (status === 401) {
      // Handle unauthorized - clear token and redirect to login
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = '/login'
    }

    return Promise.reject(error)
  }
)

export default {
  // Auth services
  auth: {
    login(credentials) {
      return apiClient.post('/auth/login', credentials)
    },
    register(userData) {
      return apiClient.post('/auth/register', userData)
    },
    getProfile() {
      return apiClient.get('/user/profile')
    },
    updateProfile(profileData) {
      return apiClient.put('/user/profile', profileData)
    },
    changePassword(passwordData) {
      return apiClient.post('/auth/change-password', passwordData)
    }
  },

  // Assets services
  assets: {
    getAll() {
      return apiClient.get('/assets?active=1&realTimePrice=-1')
    },
    getTodayPrices() {
      return apiClient.get('/assets/today-prices')
    },
    getLast30DaysPrices(assetId) {
      return apiClient.get(`/assets/${assetId}/prices/last-30-days`)
    }
  },

  // Transactions services
  transactions: {
    getAll(params = {}) {
      return apiClient.get('/user/transactions', { params })
    },
    makeCredit(transactionData) {
      return apiClient.post('/user/transactions/credit', transactionData)
    },
    makeDebit(transactionData) {
      return apiClient.post('/user/transactions/debit', transactionData)
    }
  },

  // Balances services
  balances: {
    getAll() {
      return apiClient.get('/user/balances')
    }
  },

  // System services
  system: {
    clearMyCache() {
      return apiClient.post('/user/cache/clear')
    }
  }
}
